<script>
import Option from 'element-ui/lib/option';

export default Option;
</script>

<style lang="scss">
@import '../../stylesheets/element-theme/option.css';
// Adding RTL support to element's input
</style>
